
const Divider = () => {
    return (
    <span className="flex items-center">
        <span className="h-px flex-1 bg-gray-200 mb-6"></span>
    </span>    
)

}
export default Divider;